// import React, { useState, useEffect } from 'react';
// import { Link, useLocation, useParams } from 'react-router-dom';
// import Section1 from './Sections/Section1';
// import Section2 from './Sections/Section2';
// import Section3 from './Sections/Section3';

// const InspectionForm = () => {
//   const { formId } = useParams();
//   const location = useLocation();

//   const [sectionProgress, setSectionProgress] = useState({
//     section1: 0,
//     section2: 0,
//     section3: 0,
//   });

//   useEffect(() => {
//     // Example progress calculation
//     const section1Forms = 2;
//     const section2Forms = 16;
//     const section3Forms = 4;

//     const section1Completed = 1; // Replace with actual completion logic
//     const section2Completed = 6; // Replace with actual completion logic
//     const section3Completed = 2; // Replace with actual completion logic

//     setSectionProgress({
//       section1: (section1Completed / section1Forms) * 100,
//       section2: (section2Completed / section2Forms) * 100,
//       section3: (section3Completed / section3Forms) * 100,
//     });
//   }, [formId]);

//   const renderFormSection = () => {
//     if (location.pathname.includes('section1')) {
//       return <Section1 formId={formId} />;
//     } else if (location.pathname.includes('section2')) {
//       return <Section2 formId={formId} />;
//     } else if (location.pathname.includes('section3')) {
//       return <Section3 formId={formId} />;
//     }
//     return null;
//   };

//   // Section 1 form names
//   const section1FormNames = [
//     'Pre lamination inspection in each and every stage',
//     'Post lamination inspection in each and every stage',
//   ];

//   // Section 2 form names
//   const section2FormNames = [
//     'Bill of material verification',
//     'Daily volume of the qualified modules',
//     'Stringer machine parameters verification',
//     'Peel Strength of Ribbon to string connector',
//     'Cell to ribbon peel strength',
//     'Lamination machine parameters verification',
//     'Calibration data verification of secondary module',
//     'Flash test witness record after calibration',
//     'Primary (Golden) Module Calibration record',
//     'Frame sealant weight verification',
//     'Junction Box sealant weight verification',
//     'Junction Box Potting material ratio verification',
//     'Module dimensions check',
//     'Record of rejected module during inspection',
//     'RFID Readability and data verification',
//     'Machine breakdown history'
//   ];

//   // Section 3 form names
//   const section3FormNames = [
//     'Root Cause Analysis',
//   ];

//   return (
//     <div className="p-6 max-w-7xl mx-auto">
//       {/* Section 1 */}
//       <div className="mb-12 bg-white p-8 border border-gray-300 rounded-xl shadow-md">
//         <h2 className="text-3xl font-semibold mb-6 text-gray-900">Section 1</h2>
//         <div className="relative mb-6">
//           <div className="bg-gray-300 h-6 rounded-full overflow-hidden shadow-inner">
//             <div
//               className="bg-[#424752] h-full rounded-full shadow-lg"
//               style={{ width: `${sectionProgress.section1}%` }}
//             />
//           </div>
//           <div className="absolute inset-0 flex items-center justify-center text-xs text-gray-100 font-bold tracking-wide">
//             {sectionProgress.section1.toFixed(2)}%
//           </div>
//         </div>
//         <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
//           {section1FormNames.map((name, i) => (
//             <div key={i} className="p-6 border border-gray-300 rounded-xl shadow-lg bg-white hover:bg-gray-100 transform hover:scale-105 transition-transform duration-300">
//               <p className="text-lg font-semibold text-gray-700 mb-4 truncate">
//                 {name}
//               </p>
//               <Link
//                 to={`/inspections/section1/form${i + 1}`}
//                 className="bg-[#424752] text-white px-6 py-2 rounded-md block text-center font-semibold transition-all hover:shadow-lg"
//               >
//                 Open Form
//               </Link>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Section 2 */}
//       <div className="mb-12 bg-white p-8 border border-gray-300 rounded-xl shadow-md">
//         <h2 className="text-3xl font-semibold mb-6 text-gray-900">Section 2</h2>
//         <div className="relative mb-6">
//           <div className="bg-gray-300 h-6 rounded-full overflow-hidden shadow-inner">
//             <div
//               className="bg-[#424752] h-full rounded-full shadow-lg"
//               style={{ width: `${sectionProgress.section2}%` }}
//             />
//           </div>
//           <div className="absolute inset-0 flex items-center justify-center text-xs text-gray-100 font-bold tracking-wide">
//             {sectionProgress.section2.toFixed(2)}%
//           </div>
//         </div>
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
//           {section2FormNames.map((name, i) => (
//             <div key={i} className="p-6 border border-gray-300 rounded-xl shadow-lg bg-white hover:bg-gray-100 transform hover:scale-105 transition-transform duration-300">
//               <p className="text-lg font-semibold text-gray-700 mb-4 truncate">
//                 {name}
//               </p>
//               <Link
//                 to={`/inspections/section2/form${i + 3}`}
//                 className="bg-[#424752] text-white px-6 py-2 rounded-md block text-center font-semibold transition-all hover:shadow-lg"
//               >
//                 Open Form
//               </Link>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Section 3 */}
//       <div className="mb-12 bg-white p-8 border border-gray-300 rounded-xl shadow-md">
//         <h2 className="text-3xl font-semibold mb-6 text-gray-900">Section 3</h2>
//         <div className="relative mb-6">
//           <div className="bg-gray-300 h-6 rounded-full overflow-hidden shadow-inner">
//             <div
//               className="bg-[#424752] h-full rounded-full shadow-lg"
//               style={{ width: `${sectionProgress.section3}%` }}
//             />
//           </div>
//           <div className="absolute inset-0 flex items-center justify-center text-xs text-gray-100 font-bold tracking-wide">
//             {sectionProgress.section3.toFixed(2)}%
//           </div>
//         </div>
//         <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
//           {section3FormNames.map((name, i) => (
//             <div key={i} className="p-6 border border-gray-300 rounded-xl shadow-lg bg-white hover:bg-gray-100 transform hover:scale-105 transition-transform duration-300">
//               <p className="text-lg font-semibold text-gray-700 mb-4 truncate">
//                 {name}
//               </p>
//               <Link
//                 to={`/inspections/section3/form${i + 19}`}
//                 className="bg-[#424752] text-white px-6 py-2 rounded-md block text-center font-semibold transition-all hover:shadow-lg"
//               >
//                 Open Form
//               </Link>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Render the selected form based on route */}
//       <div className="mt-12">
//         {renderFormSection()}
//       </div>
//     </div>
//   );
// };

// export default InspectionForm;



// import React, { useState, useEffect } from 'react';
// import { Link, useLocation, useParams, useNavigate } from 'react-router-dom';
// import axios from 'axios'; // Import axios for API calls
// import Section1 from './Sections/Section1';
// import Section2 from './Sections/Section2';
// import Section3 from './Sections/Section3';

// const InspectionForm = () => {
//   const { formId } = useParams();
//   const location = useLocation();
//   const [sectionProgress, setSectionProgress] = useState({
//     section1: 0,
//     section2: 0,
//     section3: 0,
//   });
//   const navigate = useNavigate(); // Hook for navigation
  

//   const section1Forms = [
//     { id: 1, name: 'Pre lamination inspection in each and every stage', completed: false },
//     { id: 2, name: 'Post lamination inspection in each and every stage', completed: true },
//   ];

//   const section2Forms = [
//     { id: 3, name: 'Bill of material verification', completed: true },
//     { id: 4, name: 'Daily volume of the qualified modules', completed: false },
//     { id: 5, name: 'Stringer machine parameters verification', completed: true },
//     { id: 6, name: 'Peel Strength of Ribbon to string connector', completed: false },
//     { id: 7, name: 'Cell to ribbon peel strength', completed: false },
//     { id: 8, name: 'Lamination machine parameters verification', completed: true },
//     { id: 9, name: 'Calibration data verification of secondary module', completed: true },
//     { id: 10, name: 'Flash test witness record after calibration', completed: false },
//     { id: 11, name: 'Primary (Golden) Module Calibration record', completed: true },
//     { id: 12, name: 'Frame sealant weight verification', completed: false },
//     { id: 13, name: 'Junction Box sealant weight verification', completed: true },
//     { id: 14, name: 'Junction Box Potting material ratio verification', completed: false },
//     { id: 15, name: 'Module dimensions check', completed: true },
//     { id: 16, name: 'Record of rejected module during inspection', completed: true },
//     { id: 17, name: 'RFID Readability and data verification', completed: false },
//     { id: 18, name: 'Machine breakdown history', completed: true },
//   ];

//   const section3Forms = [
//     { id: 19, name: 'Root Cause Analysis', completed: true },
//     // { id: 20, name: 'Packing material check', completed: false },
//   ];

//   useEffect(() => {
//     const calculateProgress = (forms) =>
//       (forms.filter((form) => form.completed).length / forms.length) * 100;
//     setSectionProgress({
//       section1: calculateProgress(section1Forms),
//       section2: calculateProgress(section2Forms),
//       section3: calculateProgress(section3Forms),
//     });
//   }, [formId]);

//   // New useEffect to call the /get_inspection API on page load
//   useEffect(() => {
//     const fetchInspectionData = async () => {
//       try {
//         const selectedProjectId = localStorage.getItem('selectedProject');
//         const inspectionDate = sessionStorage.getItem('inspectionDate');
//         const inspectionShift = sessionStorage.getItem('inspectionShift');
//         const inspectionSupplier = sessionStorage.getItem('inspectionSupplier');
//         const inspectorName = sessionStorage.getItem('username');

//         if (!selectedProjectId || !inspectionDate || !inspectionShift || !inspectionSupplier) {
//           console.error('Missing required inspection details.');
//           return;
//         }

//         const response = await axios.post('https://redoms-backend-dev.m-devsecops.com/get_inspection', {
//           projectId: selectedProjectId,
//           inspectionSupplier: inspectionSupplier,
//           inspectionDate: inspectionDate,
//           inspectionShift: inspectionShift,
//           inspectorName: inspectorName,
//         });

//         sessionStorage.setItem('inspectionData', JSON.stringify(response.data));

//         console.log('Inspection API Response:', response.data);
//       } catch (error) {
//         console.error('Error fetching inspection data:', error);
//       }
//     };

//     fetchInspectionData();
//   }, []); // Empty dependency array ensures this runs only once on component mount

//   const renderFormSection = () => {
//     if (location.pathname.includes('section1')) {
//       return <Section1 formId={formId} />;
//     } else if (location.pathname.includes('section2')) {
//       return <Section2 formId={formId} />;
//     } else if (location.pathname.includes('section3')) {
//       return <Section3 formId={formId} />;
//     }
//     return null;
//   };

//   const handleBackToForms = () => {
//     navigate('/inspections');
//   };

//   const renderSection = (sectionTitle, forms, progress, sectionKey) => (
//     <div className="mb-12 bg-white p-8 border border-gray-300 rounded-xl shadow-md">
//       <h2 className="text-3xl font-semibold mb-6 text-gray-900">{sectionTitle}</h2>
//       <div className="relative mb-6">
//         <div className="bg-gray-300 h-6 rounded-full overflow-hidden shadow-inner">
//           <div
//             className="bg-[#424752] h-full rounded-full shadow-lg"
//             style={{ width: `${progress}%` }}
//           />
//         </div>
//         <div className="absolute inset-0 flex items-center justify-center text-xs text-gray-100 font-bold tracking-wide">
//           {progress.toFixed(2)}%
//         </div>
//       </div>
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6">
//         {forms.map((form) => (
//           <div
//             key={form.id}
//             className={`p-6 border rounded-xl shadow-lg bg-white hover:bg-gray-100 transform hover:scale-105 transition-transform duration-300 ${
//               form.completed ? 'border-green-500' : 'border-red-500'
//             }`}
//           >
//             <p className="text-lg font-semibold text-gray-700 mb-4 truncate">
//               {form.name}
//             </p>
//             <p
//               className={`text-sm font-semibold ${
//                 form.completed ? 'text-green-600' : 'text-red-600'
//               }`}
//             >
//               {form.completed ? 'Completed' : 'Pending'}
//             </p>
//             <Link
//               to={`/inspections/${sectionKey}/form${form.id}`}
//               className="bg-[#424752] text-white px-6 py-2 rounded-md block text-center font-semibold transition-all hover:shadow-lg mt-4"
//             >
//               Open Form
//             </Link>
//           </div>
//         ))}
//       </div>
//     </div>
//   );

//   return (
//       <div className="p-2 w-full">
//         <button
//           onClick={handleBackToForms}
//           className="mb-4 inline-flex items-center text-gray-700 hover:text-gray-600 font-bold text-md focus:outline-none focus:underline"
//         >
//           ← Back to Start Inspection
//         </button>

//       {renderSection('Section 1', section1Forms, sectionProgress.section1, 'section1')}
//       {renderSection('Section 2', section2Forms, sectionProgress.section2, 'section2')}
//       {renderSection('Section 3', section3Forms, sectionProgress.section3, 'section3')}
//       <div className="mt-5">{renderFormSection()}</div>
//     </div>
//   );
// };

// export default InspectionForm;

import React, { useState, useEffect } from 'react';
import { Link, useLocation, useParams, useNavigate } from 'react-router-dom';
import axios from 'axios'; // Import axios for API calls
import Section1 from './Sections/Section1';
import Section2 from './Sections/Section2';
import Section3 from './Sections/Section3';
import apiClient from '../../pages/keycloak/axiosInstance';

const InspectionForm = () => {
  const { formId } = useParams();
  const location = useLocation();
  const [sectionProgress, setSectionProgress] = useState({
    section1: 0,
    section2: 0,
    section3: 0,
  });
  const navigate = useNavigate(); // Hook for navigation

  const [section1Forms, setSection1Forms] = useState([
    { id: 1, name: 'Pre lamination inspection in each and every stage', completed: false },
    { id: 2, name: 'Post lamination inspection in each and every stage', completed: false },
  ]);

  const [section2Forms, setSection2Forms] = useState([
    { id: 3, name: 'Bill of material verification', completed: false },
    { id: 4, name: 'Daily volume of the qualified modules', completed: false },
    { id: 5, name: 'Stringer machine parameters verification', completed: false },
    { id: 6, name: 'Peel Strength of Ribbon to string connector', completed: false },
    { id: 7, name: 'Cell to ribbon peel strength', completed: false },
    { id: 8, name: 'Lamination machine parameters verification', completed: false },
    { id: 9, name: 'Calibration data verification of secondary module', completed: false },
    { id: 10, name: 'Flash test witness record after calibration', completed: false },
    { id: 11, name: 'Primary (Golden) Module Calibration record', completed: false },
    { id: 12, name: 'Frame sealant weight verification', completed: false },
    { id: 13, name: 'Junction Box sealant weight verification', completed: false },
    { id: 14, name: 'Junction Box Potting material ratio verification', completed: false },
    { id: 15, name: 'Module dimensions check', completed: false },
    { id: 16, name: 'Record of rejected module during inspection', completed: false },
    { id: 17, name: 'RFID Readability and data verification', completed: false },
    { id: 18, name: 'Machine breakdown history', completed: false },
  ]);

  const [section3Forms, setSection3Forms] = useState([
    { id: 19, name: 'Root Cause Analysis', completed: false },
  ]);

  useEffect(() => {
    const calculateProgress = (forms) =>
      (forms.filter((form) => form.completed).length / forms.length) * 100;
    setSectionProgress({
      section1: calculateProgress(section1Forms),
      section2: calculateProgress(section2Forms),
      section3: calculateProgress(section3Forms),
    });
  }, [formId, section1Forms, section2Forms, section3Forms]);

  useEffect(() => {
    const fetchInspectionData = async () => {
      try {
        const selectedProjectId = localStorage.getItem('selectedProject');
        const inspectionDate = sessionStorage.getItem('inspectionDate');
        const inspectionShift = sessionStorage.getItem('inspectionShift');
        const inspectionSupplier = sessionStorage.getItem('inspectionSupplier');
        const inspectorName = sessionStorage.getItem('username');
        const baseURL = process.env.REACT_APP_API_BASE_URL;

  
        if (!selectedProjectId || !inspectionDate || !inspectionShift || !inspectionSupplier) {
          console.error('Missing required inspection details.');
          return;
        }
  
        const response = await apiClient.post(`get_inspection`, {
          projectId: selectedProjectId,
          inspectionSupplier: inspectionSupplier,
          inspectionDate: inspectionDate,
          inspectionShift: inspectionShift,
        });
  
        sessionStorage.setItem('inspectionData', JSON.stringify(response.data[0]));
  
        const inspectionData = response.data[0];
  
        // Update section1Forms for both PreLamination and PostLamination
        setSection1Forms((prevSection1Forms) =>
          prevSection1Forms.map((form) => {
            if (form.id === 1 && inspectionData?.PreLamination) {
              const preLaminationKeys = [
                'CellAndCuttingMachine_pre',
                'GlassFrontBack_pre',
                'PreLaminationELRework_pre',
                'TabbingStringing_pre',
                'autoBussing_pre',
                'barCodeRFID_pre',
                'encapsulationMaterialBack_pre',
                'encapsulationMaterialFront_pre',
                'shopFloor_pre',
              ];
              const presentPreLaminationKeys = preLaminationKeys.filter(
                (key) => inspectionData.PreLamination[key] !== undefined
              );
              return {
                ...form,
                completed: presentPreLaminationKeys.length === preLaminationKeys.length,
              };
            }
            if (form.id === 2 && inspectionData?.PostLamination) {
              const postLaminationKeys = [
                'Cleaning_post',
                'Curing_post',
                'Framing_post',
                'HiPot_post',
                'JbAssemblingSoldering_post',
                'Lamination_post',
                'Packing_post',
                'PostLaminationEL_post', 
                'Trimming_post',
                'VisualInspections_post',
                'electricalTest_post',
              ];
              const presentPostLaminationKeys = postLaminationKeys.filter(
                (key) => inspectionData.PostLamination[key] !== undefined
              );
              return {
                ...form,
                completed: presentPostLaminationKeys.length === postLaminationKeys.length,
              };
            }
            return form;
          })
        );
  
        // // Log updated section1Forms for debugging
        // setSection1Forms((prev) => {
        //   console.log('Updated section1Forms:', prev);
        //   return prev;
        // });
  
        // Logic for Section 2 Forms (unchanged)
        const updatedSection2Forms = section2Forms.map((form) => {
          switch (form.id) {
            case 3:
              if (inspectionData && inspectionData.BOM) {
                const bomKeys = [
                  'AdhesiveSealant',
                  'Cell',
                  'Frame',
                  'cellFixingType',
                  'evaBack',
                  'evaFront',
                  'flux',
                  'glassBack',
                  'glassFront',
                  'interconnector',
                  'junctionBox',
                  'pottingMaterial',
                  'stringConnector',
                ];
                const presentBOMKeys = bomKeys.filter((key) => inspectionData.BOM[key] !== undefined);
                return { ...form, completed: presentBOMKeys.length === bomKeys.length };
              }
              break;
            case 4:
              return { ...form, completed: inspectionData && inspectionData.dailyVolumeQualifiedModules !== undefined };
            case 5:
              if (inspectionData && inspectionData.stringer) {
                const stringerKeys = ['STR1', 'STR2', 'STR3', 'STR4', 'STR5', 'STR6'];
                const presentStringerKeys = stringerKeys.filter((key) => inspectionData.stringer[key] !== undefined);
                return { ...form, completed: presentStringerKeys.length === stringerKeys.length };
              }
              break;
            case 6:
              return { ...form, completed: inspectionData && inspectionData.PeelStrength !== undefined };
            case 7:
              return { ...form, completed: inspectionData && inspectionData.CellToRibbonPeelStrength !== undefined };
            case 8:
              return { ...form, completed: inspectionData && inspectionData.LaminationMachine !== undefined };
            case 9:
              return { ...form, completed: inspectionData && inspectionData.calibrationVerificationOfSecondaryModule !== undefined };
            case 10:
              return { ...form, completed: inspectionData && inspectionData.FlashTestWitnessRecordAfterCalibration !== undefined };
            case 11:
              return { ...form, completed: inspectionData && inspectionData.PrimaryModuleCalibrationRecord !== undefined };
            case 12:
              return { ...form, completed: inspectionData && inspectionData.FrameSealantWeightVerification !== undefined };
            case 13:
              return { ...form, completed: inspectionData && inspectionData.JunctionBoxSealantWeightVerification !== undefined };
            case 14:
              return { ...form, completed: inspectionData && inspectionData.JunctionBoxPottingMaterial !== undefined };
            case 15:
              return { ...form, completed: inspectionData && inspectionData.ModuleDimensionCheck !== undefined };
            case 16:
              return { ...form, completed: inspectionData && inspectionData.RecordRejectedModuleDuringInspection !== undefined };
            case 17:
              return { ...form, completed: inspectionData && inspectionData.RFIDReadability !== undefined };
            case 18:
              return { ...form, completed: inspectionData && inspectionData.MachineBreakdownHistory !== undefined };
            default:
              return form;
          }
          return form;
        });
  
        setSection2Forms(updatedSection2Forms);
  
        // Logic for Section 3 Forms (unchanged)
        const updatedSection3Forms = section3Forms.map((form) => {
          if (form.id === 19) {
            return { ...form, completed: inspectionData && inspectionData.RootCauseAnalysis !== undefined };
          }
          return form;
        });
  
        setSection3Forms(updatedSection3Forms);
  
      } catch (error) {
        console.error('Error fetching inspection data:', error);
      }
    };
  
    fetchInspectionData();
  }, []);
  
  const renderFormSection = () => {
    if (location.pathname.includes('section1')) {
      return <Section1 formId={formId} />;
    } else if (location.pathname.includes('section2')) {
      return <Section2 formId={formId} />;
    } else if (location.pathname.includes('section3')) {
      return <Section3 formId={formId} />;
    }
    return null;
  };

  const handleBackToForms = () => {
    navigate('/inspections');
  };

  const renderSection = (sectionTitle, forms, progress, sectionKey) => (
    <div className="mb-12 bg-white p-8 border border-gray-300 rounded-xl shadow-md">
      <h2 className="text-3xl font-semibold mb-6 text-gray-900">{sectionTitle}</h2>
      <div className="relative mb-6">
        <div className="bg-gray-300 h-6 rounded-full overflow-hidden shadow-inner">
          <div
            className="bg-[#424752] h-full rounded-full shadow-lg"
            style={{ width: `${progress}%` }}
          />
        </div>
        <div className="absolute inset-0 flex items-center justify-center text-xs text-gray-100 font-bold tracking-wide">
          {progress.toFixed(2)}%
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6">
        {forms.map((form) => (
          <div
            key={form.id}
            className={`p-6 border rounded-xl shadow-lg bg-white hover:bg-gray-100 transform hover:scale-105 transition-transform duration-300 ${
              form.completed ? 'border-green-500' : 'border-red-500'
            }`}
          >
            <p className="text-lg font-semibold text-gray-700 mb-4 truncate">
              {form.name}
            </p>
            <p
              className={`text-sm font-semibold ${
                form.completed ? 'text-green-600' : 'text-red-600'
              }`}
            >
              {form.completed ? 'Completed' : 'Pending'}
            </p>
            <Link
              to={`/inspections/${sectionKey}/form${form.id}`}
              className="bg-[#424752] text-white px-6 py-2 rounded-md block text-center font-semibold transition-all hover:shadow-lg mt-4"
            >
              Open Form
            </Link>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="p-2 w-full">
      <button
        onClick={handleBackToForms}
        className="mb-4 inline-flex items-center text-gray-700 hover:text-gray-600 font-bold text-md focus:outline-none focus:underline"
      >
        ← Back to Start Inspection
      </button>

      {renderSection('Section 1', section1Forms, sectionProgress.section1, 'section1')}
      {renderSection('Section 2', section2Forms, sectionProgress.section2, 'section2')}
      {renderSection('Section 3', section3Forms, sectionProgress.section3, 'section3')}
      <div className="mt-5">{renderFormSection()}</div>
    </div>
  );
};

export default InspectionForm;